/**
 * Check if an argument is defined.
 * Useful for filtering arrays: `[a, b, c].filter(isDefined)`
 * @param argument The argument to check.
 * @returns true if the argument is defined, false otherwise.
 */
export function isDefined<T>(argument: T | undefined): argument is T {
  return argument !== undefined;
}

export function joinArrayAsSentence(items: string[] | undefined): string | undefined {
  if (!items?.length) return;
  if (items.length === 1) return items[0];
  const allButLast = items.slice(0, -1);
  const lastItem = items[items.length - 1];
  return `${allButLast.join(", ")} and ${lastItem}`;
}
